import React, { useState, useEffect } from 'react';
import { Card, CardContent, Button, Select, Box, Typography, Container, TextField, Radio, Grid, RadioGroup, FormControlLabel, Divider, FormControl, InputLabel, MenuItem, FormHelperText, DialogActions, DialogContent, Dialog, DialogTitle } from '@mui/material';
import { PROD } from '../../../common/constants';

import { loaderService } from "../../../common/custom-loader/loader-service";
import { toast } from 'react-toastify';
import { GENERATE_SES, GET_APPROVED_STAKEHOLDERS, GET_GRN_LIST_BY_SERVICE_PO, GET_INVOICE_NUMBER_LIST_FOR_SES, GET_MANUAL_PO_LIST } from '../../../common/URLs';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import CustomDataGridToolbar from '../../../common/customDataGridToolbar';
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from "react-router-dom";
import moment from 'moment';
import { capitalizeFunction, VALIDATION } from '../../../common/commonValidations';
import { ConfirmationPopover } from '../../../common/commonPopovers/confirmationPopover';
import apiClient from '../../../axios';

function GenerateSes() {

    const navigate = useNavigate();
    const URN = localStorage.getItem('urn');
    const StakeholderCategory = localStorage.getItem('stakeholderCategory');

    const [details, setDetails] = useState({
        stakeholderType: URN ? StakeholderCategory : "",
        stakeholderUrn: URN ? URN : "",
        invoiceNumber: "",
        comment: ""
    });
    const [errorMessage, setErrorMessage] = useState({
        stakeholderType: "",
        stakeholderUrn: "",
        invoiceNumber: "",
        comment: ""
    });
    const [invoiceList, setInvoiceList] = useState([]);
    const [grnList, setGrnList] = useState([]);
    const [urnList, setUrnList] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [proceed, setProceed] = useState(false);
    const [isApiCalled, setIsApiCalled] = useState(false);

    const [logModalOpen, setLogModalOpen] = useState(false);
    const handleLogModalOpen = () => setLogModalOpen(true);
    const handleLogModalClose = () => setLogModalOpen(false);

    const grnColumns = [
        { field: 'poNumber', headerName: "PO Number", width: 150 },
        { field: 'grnNo', headerName: "GRN Number", width: 110 },
        { field: 'consignmentNo', headerName: "Consignment Number", width: 170 },
        { field: 'stakeholderName', headerName: "Stakeholder Name", width: 150 },
        { field: 'stakeholderType', headerName: "Stakeholder Type", width: 150 },
        { field: 'stakeholderUrn', headerName: "Stakeholder Urn", width: 150 },
        { field: 'vehicleRegNo', headerName: "Vehicle Number", width: 150 },
        { field: 'materialType', headerName: "Material Type", width: 130 },
        { field: 'deliveryLocation', headerName: "Delivery Location", width: 150 },
        { field: 'deliveryUrn', headerName: "Delivery Urn", width: 150 },
        {
            field: 'deliveryDate', headerName: "Delivery Date", width: 120,
            valueFormatter: params => params?.value && moment(params?.value).format("DD/MM/YYYY"),
        },
        { field: 'distanceTravelled', headerName: "Distance Travelled(in KM)", width: 190 },
        { field: 'deliveryChallanNo', headerName: "Delivery Challan Number", width: 180 },
        { field: 'grnQuantity', headerName: "GRN Quantity(in MT)", width: 150 },
        { field: 'rate', headerName: "Rate(in INR)", width: 150 },
        { field: 'amount', headerName: "Amount(in INR)", width: 150 },
        { field: 'tax', headerName: "Gst(in INR)", width: 150 },
        { field: 'consignmentStatus', headerName: "Status", width: 150 },
    ]

    useEffect(() => {
        URN && getInvoiceList(details.stakeholderUrn);
    }, [URN]);

    const handleChange = (e) => {
        setProceed(false);
        setDetails({ ...details, [e.target.name]: e.target.value });
        setErrorMessage({ ...errorMessage, [e.target.name]: "" });
        if (e.target.name === "stakeholderType") {
            getUrnList(e.target.value)
        }
        if (e.target.name === "stakeholderUrn") {
            getInvoiceList(e.target.value)
        }
    }

    const onProceed = () => {
        if (!details.stakeholderType) {
            setErrorMessage({ ...errorMessage, stakeholderType: "Please select stakeholder type" })
        }
        else if (!details.stakeholderUrn) {
            setErrorMessage({ ...errorMessage, stakeholderUrn: "Please select stakeholder urn" })
        }
        else if (!details.invoiceNumber) {
            setErrorMessage({ ...errorMessage, invoiceNumber: "Please select invoice number" })
        }
        else {
            setProceed(true);
            getGrnList();
        }
    }

    const onCreateSes = () => {
        if (!details.comment) {
            setErrorMessage({ ...errorMessage, comment: "Please enter comment" })
        }
        else {
            handleLogModalOpen();
        }
    }

    // const onConfirmSubmit = () => {
    //     handleLogModalClose();
    //     generateSes();
    //   }

    
 
    const onConfirmSubmit = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await generateSes();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setLogModalOpen(false);
            setIsApiCalled(false);
        }
    };

    const getUrnList = (stakeholderTypeValue) => {
        loaderService.showLoader();
        apiClient.post(GET_APPROVED_STAKEHOLDERS,
            {
                "type": stakeholderTypeValue
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setUrnList(response.data.stakeHolders);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const getInvoiceList = (stakeholderUrnValue) => {
        loaderService.showLoader();
        apiClient.post(GET_INVOICE_NUMBER_LIST_FOR_SES,
            {
                "stakeholderType": details.stakeholderType,
                "stakeholderUrn": stakeholderUrnValue,
                "isSesCreated": false
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setInvoiceList(response.data.invoiceNumberList)
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const getGrnList = () => {
        loaderService.showLoader();
        apiClient.post(GET_GRN_LIST_BY_SERVICE_PO,
            {
                "invoiceNumber": details.invoiceNumber,
                "isSesCreated": false
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setGrnList(response?.data?.grnDetailsList);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const generateSes = () => {
        loaderService.showLoader();
        apiClient.post(GENERATE_SES,
            {
                "stakeholderType": details.stakeholderType,
                "stakeholderUrn": details.stakeholderUrn,
                "roleName": localStorage.getItem('role'),
                "userName": localStorage.getItem('userName'),
                "invoiceNumber": details.invoiceNumber,
                "comment": details.comment,
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                if (response.data?.isSuccess == true) {
                    toast.success(response.data.message);
                    setProceed(false);
                }
                else if (response.data?.isSuccess == false) {
                    toast.error(response.data.message);
                }
                else {
                    toast.error("Error! Please try again");
                }
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT57</p>}
                <Typography variant="h4" gutterBottom>
                    Create SES
                </Typography>
                <Card>
                    <CardContent>
                        <Grid container spacing={1} >
                            {!URN && <><Grid item xs={12} lg={3}>
                                <FormControl fullWidth size="small" required={errorMessage.stakeholderType}>
                                    <InputLabel>Stakeholder Type</InputLabel>
                                    <Select label="Stakeholder Type" name="stakeholderType" value={details.stakeholderType || ''} onChange={(e) => handleChange(e)}>
                                        <MenuItem value="Transporter">Transporter</MenuItem>
                                        <MenuItem value="HIT">HIT</MenuItem>
                                    </Select>
                                    <FormHelperText sx={{ color: 'red' }}>{errorMessage.stakeholderType}</FormHelperText>
                                </FormControl>
                            </Grid>
                                <Grid item xs={12} lg={3}>
                                    <FormControl fullWidth size="small" required error={errorMessage.stakeholderUrn}>
                                        <InputLabel>Stakeholder URN</InputLabel>
                                        <Select label="Stakeholder URN" value={details.stakeholderUrn || ''} name="stakeholderUrn" onChange={(e) => handleChange(e)}>
                                            {urnList &&
                                                urnList?.map((item) => (
                                                    <MenuItem value={item.urn}>{item.urn}</MenuItem>

                                                ))}
                                        </Select>
                                        <FormHelperText sx={{ color: 'red' }}>{errorMessage.stakeholderUrn}</FormHelperText>
                                    </FormControl>
                                </Grid>
                            </>}
                            <Grid item xs={12} lg={3}>
                                <FormControl fullWidth size="small" required error={errorMessage.invoiceNumber}>
                                    <InputLabel>Invoice Number</InputLabel>
                                    <Select label="Invoice Number" name="invoiceNumber" value={details.invoiceNumber} onChange={(e) => handleChange(e)}>
                                        {invoiceList &&
                                            invoiceList?.map((items) => (
                                                <MenuItem value={items}>{items}</MenuItem>
                                            ))}
                                    </Select>
                                    <FormHelperText sx={{ color: 'red' }}>{errorMessage.invoiceNumber}</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} lg={3}>
                                <Button variant="contained" onClick={onProceed}>Proceed</Button>
                            </Grid>
                            {grnList.length > 0 && proceed &&
                                <>
                                    <Grid item xs={12}>
                                        <Box style={{ height: 500, width: '100%' }}>
                                            <DataGrid
                                                rows={grnList}
                                                columns={grnColumns}
                                                // checkboxSelection
                                                pageSize={10}
                                                getRowId={(row) => row?.grnNo}
                                                // onSelectionModelChange={(ids) => {
                                                //     const selectedIDs = new Set(ids);
                                                //     const selectedRowData = grnList?.filter((row) =>
                                                //         selectedIDs.has(row.grnNo.toString())
                                                //     )
                                                //     setSelectedRows(selectedRowData);
                                                // }}
                                                components={{
                                                    Toolbar: CustomDataGridToolbar,
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <TextField fullWidth
                                            error={errorMessage.comment}
                                            helperText={errorMessage.comment}
                                            multiline
                                            label="Comment"
                                            value={details.comment}
                                            onChange={(e) => { setDetails({ ...details, comment: VALIDATION.noSpecialCharacterValidation(capitalizeFunction(e.target.value)) }); setErrorMessage({ ...errorMessage, comment: "" }); }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} mt={2}>
                                        <Button variant="contained" onClick={onCreateSes} style={{ float: "right" }}>Create SES</Button>
                                    </Grid>
                                </>}
                        </Grid>
                    </CardContent>
                </Card>
            </Container>
            <ConfirmationPopover onOpen={logModalOpen} onConfirm={onConfirmSubmit} onClose={handleLogModalClose} action="Submit" />
        </>
    )
}

export default GenerateSes;